import React from "react";

const Loader = () => {
  return (
    <div id="preloader" className="preloader">
      <button className="th-btn th-radius preloaderCls">
        Cancel Preloader
      </button>
      <div id="loader" className="th-preloader">
        <div className="animation-preloader">
          <div className="txt-loading">
            <span preloader-text="H" className="characters">
              H
            </span>
            <span preloader-text="E" className="characters">
              E
            </span>
            <span preloader-text="A" className="characters">
              A
            </span>
            <span preloader-text="L" className="characters">
              L
            </span>
            <span preloader-text="I" className="characters">
              I
            </span>
            <span preloader-text="X" className="characters">
              X
            </span>
            <span preloader-text="S" className="characters">
              S
            </span>
            <span preloader-text="O" className="characters">
              O
            </span>
            <span preloader-text="F" className="characters">
              F
            </span>
            <span preloader-text="T" className="characters">
              T
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loader;

// import React, { useEffect, useState } from "react";

// const Loader = () => {
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     // Simulate page load
//     const handleLoad = () => {
//       setTimeout(() => {
//         setLoading(false);
//       }, 800);
//     };

//     handleLoad();
//   }, []);

//   if (!loading) return null;

//   return (
//     <div id="preloader" className="preloader">
//       <button
//         className="th-btn th-radius preloaderCls"
//         onClick={() => setLoading(false)}
//       >
//         Cancel Preloader
//       </button>

//       <div id="loader" className="th-preloader">
//         <div className="animation-preloader">
//           <div className="txt-loading">
//             {"HEALIXSOFT".split("").map((char, i) => (
//               <span key={i} preloader-text={char} className="characters">
//                 {char}
//               </span>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Loader;
